import social from 'fixtures/social.json';

/**
 * Expose all endponts for 'indicators'.
 */
export const socialIndicatorsApiMock = () => ({
  getFbInfo: filters =>
    new Promise(resolve => {
      setTimeout(() => {
        resolve({
          data: [],
          ok: true
        });
      }, 1000);
    }),
  getTwitterInfo: filters =>
    new Promise(resolve => {
      setTimeout(() => {
        resolve({
          data: [],
          ok: true
        });
      }, 1000);
    })
});

export const socialIndicatorsApi = api => ({
  getFbInfo: filters => api.get(`/social/info`, filters),
  getTwitterInfo: filters => api.get(`/social/info`, filters)
});



// WEBPACK FOOTER //
// ./src/services/api/socialIndicatorsApi.js